<template>
    <wide-card>
        <div
            ref="card"
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900 "
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="flex justify-between bpi-card" v-show="show">
            <h2
                ref="scrollToMe"
                @click="show = !show"
                class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10 bpi-collapsed-card-title"
            >
                {{ investor.firstName }}
            </h2>
            <div @click="removeInvestor">
                <base-icon
                    width="60"
                    height="60"
                    class="h-8 cursor-pointer"
                    icon-name="trash"
                    viewBox="0 0 20 20 "
                    iconColor="#6C98C6"
                >
                    <icon-trash />
                </base-icon>
            </div>
        </div>
        <div v-show="!show">
            <div class="text-left">
                <label
                    class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                    >Quelles sont vos motivations pour créer votre entreprise
                    ?</label
                >
                <multiselect
                    v-model="investor.motivations"
                    tag-placeholder="Add this as new tag"
                    placeholder="Search or add a tag"
                    label="name"
                    track-by="code"
                    :options="motivationOptions"
                    :multiple="true"
                    :taggable="false"
                ></multiselect>
            </div>
            <base-input
                placeholder="Votre prénom"
                v-model="investor.firstName"
                :hasError="$v.investor.firstName.$error"
                :errorMessage="errorMessage('prenom', $v.investor.firstName)"
                @blur="$v.investor.firstName.$touch()"
            />
            <base-input
                placeholder="Votre nom"
                v-model="investor.lastName"
                :hasError="$v.investor.lastName.$error"
                :errorMessage="errorMessage('nom', $v.investor.lastName)"
                @blur="$v.investor.lastName.$touch()"
            />
            <div class="text-left">
                <label
                    class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                    >Votre Sexe</label
                >
                <div class="flex">
                    <icon-card
                        :value="investor.sex"
                        class="flex flex-col items-center justify-center max-w-sm"
                        title="Femme"
                        ref="womenIcon"
                        v-on:clicked="sexHandler('women')"
                    >
                        <icon-women />
                    </icon-card>
                    <icon-card
                        title="Homme"
                        :value="investor.sex"
                        ref="manIcon"
                        v-on:clicked="sexHandler('man')"
                        class="flex flex-col items-center justify-center max-w-sm ml-6"
                    >
                        <icon-men />
                    </icon-card>
                </div>
            </div>
            <date-picker
                label="Date de naissance"
                :value="
                    investor.birthday.seconds !== undefined
                        ? new Date(investor.birthday.seconds * 1000)
                        : investor.birthday
                "
                v-on:setDate="payload => (investor.birthday = payload)"
            />
            <select-menu
                label="Votre situation familiale"
                :option="situationFamilialeLis"
                v-model="investor.SituationFamiliale"
            />
            <base-input
                placeholder="Votre numéro CIN"
                v-model="investor.CIN"
                :hasError="$v.investor.CIN.$error"
                :errorMessage="errorMessage('CIN', $v.investor.CIN)"
                @blur="$v.investor.CIN.$touch()"
            />
            <base-input
                placeholder="Votre adresse"
                v-model="investor.address"
                :hasError="$v.investor.address.$error"
                :errorMessage="errorMessage('addresse', $v.investor.address)"
                @blur="$v.investor.address.$touch()"
            />
            <div class="mt-4 ml-3 text-left">
                <label
                    class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                    >Mobilité réduite</label
                >
                <radio-box
                    label="Oui"
                    name="mobilite"
                    :value="investor.mobilite_reduite ? 'Oui' : 'Non'"
                    @change="payload => (investor.mobilite_reduite = payload)"
                />
                <radio-box
                    class="ml-6"
                    label="Non"
                    :value="investor.mobilite_reduite ? 'Oui' : 'Non'"
                    name="mobilite"
                    @change="payload => (investor.mobilite_reduite = payload)"
                />
            </div>
            <base-input
                placeholder="Votre email"
                v-model="investor.email"
                :hasError="$v.investor.email.$error"
                :errorMessage="errorMessage('email', $v.investor.email)"
                @blur="$v.investor.email.$touch()"
            />
            <base-input
                placeholder="Votre téléphone"
                v-model="investor.phone"
                :hasError="$v.investor.phone.$error"
                :errorMessage="errorMessage('telephone', $v.investor.phone)"
                @blur="$v.investor.phone.$touch()"
            />
            <select-menu
                label="Niveau de formation"
                :option="formationList"
                v-model="investor.niveauDeFormation"
            />
            <base-input
                v-model="investor.niveauDeFormationAutre"
                v-if="investor.niveauDeFormation === 'autre'"
                placeholder="Précisez..."
            />
            <select-menu
                label="Expérience professionnelle"
                :option="expProList"
                v-model="investor.experiencePro"
            />
            <base-input
                v-model="investor.experienceProAutre"
                v-if="investor.experiencePro === 'autre'"
                placeholder="Précisez..."
            />
            <base-number-input
                v-if="investor.experiencePro !== 'Sans expérience'"
                label="Nombre d’années d’expérience"
                v-model="investor.yearsOfExperience"
                :hasError="$v.investor.yearsOfExperience.$error"
                :errorMessage="
                    errorMessage(
                        'Nombre d’années d’expérience',
                        $v.investor.yearsOfExperience
                    )
                "
                @blur="$v.investor.yearsOfExperience.$touch()"
            />
            <div class="ml-3 text-left">
                <label
                    class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                    >Pensez-vous avoir besoin d’une formation complèmentaire
                    dans :</label
                >
                <check-box
                    label="La gestion financière"
                    :selectedValues="investor.formationNeed"
                    v-on:checked="checkedHandler"
                />
                <check-box
                    :selectedValues="investor.formationNeed"
                    label="La gestion du personnel"
                    v-on:checked="checkedHandler"
                />
                <check-box
                    :selectedValues="investor.formationNeed"
                    label="Le développement du portefeuille client"
                    v-on:checked="checkedHandler"
                />
                <check-box
                    :selectedValues="investor.formationNeed"
                    label="La relation avec les tiers"
                    v-on:checked="checkedHandler"
                />
            </div>
            <div class="flex justify-end mt-4 ">
                <base-secondary-button
                    color="red"
                    title="Supprimer"
                    @click="removeInvestor"
                />
            </div>
        </div>
    </wide-card>
</template>

<script>
import WideCard from "../../../../components/cards/wideCard";
import SelectMenu from "../../../../components/forms/select/selectMenu";
import IconWomen from "../../../../components/icons/IconWomen";
import IconMen from "../../../../components/icons/IconMen";
import IconCard from "../../../../components/cards/IconCard";
import DatePicker from "../../../../components/forms/DatePicker";
import CheckBox from "../../../../components/forms/Toggles/CheckBox";
import RadioBox from "../../../../components/forms/Toggles/radioBox";
import IconTrash from "../../../../components/icons/trash";
import { mapState } from "vuex";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToRef } from "@/mixins/scrollToMixin.js";
import {
    required,
    alphaNum,
    email,
    numeric,
    minLength,
    maxLength
} from "vuelidate/lib/validators";

export default {
    components: {
        WideCard,
        IconTrash,
        SelectMenu,
        IconWomen,
        IconCard,
        IconMen,
        DatePicker,
        CheckBox,
        RadioBox
    },

    mixins: [errorMessage, scrollToRef],

    validations: {
        investor: {
            lastName: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(25)
            },
            firstName: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(25)
            },
            CIN: {
                alphaNum,
                minLength: minLength(3),
                maxLength: maxLength(15)
            },
            address: { minLength: minLength(3), maxLength: maxLength(150) },
            email: { email, minLength: minLength(3), maxLength: maxLength(60) },
            phone: {
                numeric,
                minLength: minLength(3),
                maxLength: maxLength(15)
            },
            yearsOfExperience: { numeric }
        }
    },
    // watch: {
    //   object(newVal) {
    //     this.investor = newVal;
    //   },
    // },
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            show: false,

            investor: this.data
        };
    },
    computed: {
        ...mapState("forms", {
            motivationOptions: state =>
                state.ProfilsDesInvestisseurs.motivationOptions,
            formationList: state => state.ProfilsDesInvestisseurs.formationList,
            expProList: state => state.ProfilsDesInvestisseurs.expProList,
            situationFamilialeLis: state =>
                state.ProfilsDesInvestisseurs.situationFamilialeLis
        })
    },
    methods: {
        createInvestor() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "ProfilsDesInvestisseurs/createInvestor",
                    this.investor
                );
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        sexHandler(payload) {
            if (payload === "man") {
                this.$refs.womenIcon.setValue();
                this.investor.sex = "homme";
            }
            if (payload === "women") {
                this.$refs.manIcon.setValue();
                this.investor.sex = "femme";
            }
        },
        checkedHandler(payload) {
            if (this.investor.formationNeed.includes(payload)) {
                this.investor.formationNeed.splice(
                    this.investor.formationNeed.indexOf(payload),
                    1
                );
            } else {
                this.investor.formationNeed.push(payload);
            }
        },
        removeInvestor() {
            this.$emit("remove", this.investor.id);
        },
        collapseCard() {
            this.show = false;
        }
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
    border-radius: 15px;
}
</style>
